import {
  ADD_EMAILS_TO_SUPPLIER,
  ADD_VENDORS_TO_RFQ,
  APPROVE_RFQ_APPROVAL_URL,
  CHANGE_STATUS,
  CLOSE_RFQ,
  CLOSE_RFQ_V2,
  CLOSE_RFQ_WITHOUT_VENDOR,
  CREATE_NEW_PROJECT,
  DELETE_RFQ,
  DELETE_SINGLE_RFQ,
  EDIT_RFQ,
  EDIT_RFQ_PROJECT,
  GET_APPROVED_RFQ,
  GET_INDENT_DETAILS,
  GET_MATERIAL_MASTER,
  GET_PENDING_PR_MATERIALS,
  GET_MEMBER_LIST,
  GET_RFQ,
  GET_RFQS,
  GET_RFQS_BY_STATUS,
  GET_RFQ_PROJECTS,
  GET_USER_CONTACTS_BY_ID,
  INVITE_VENDORS,
  MUL_REINVITE_RFQ,
  QUOTATION_RECEIVED,
  REINVITE_RFQ,
  REJECT_RFQ_APPROVAL_URL,
  REMOVE_VENDORS_RFQ,
  RESTORE_RFQ,
  RFQ_FILTER_DATE,
  SAVE_RFQ,
  SEARCH_RFQ,
  SEND_RFQ,
  SEND_RFQ_FOR_APPROVAL_URL,
  TRASH_RFQ,
  UPDATE_EMAIL_VENDOR,
  UPDATE_RFQ_DISPLAY_RANKS,
  UPDATE_RFQ_COMPARISON_EXCLUSION,
  REQUEST_RFQ_QUOTATION_UPDATE,
} from "config/services";
import axios from "utils/axios";

class RfqService {
  saveRfq = (newReqInfo) =>
    new Promise((resolve, reject) => {
      axios
        .post(SAVE_RFQ, newReqInfo)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  fetchIndentDetails = ({ entityId, indentId, rfqType }) =>
    new Promise((resolve, reject) => {
      if (!entityId || !indentId) {
        reject(new Error("entityId and indentId are required"));
        return;
      }

      const rfqTypeQuery = rfqType
        ? `&rfqType=${encodeURIComponent(rfqType)}`
        : "";

      axios
        .get(
          `${GET_INDENT_DETAILS}?entityId=${encodeURIComponent(
            entityId
          )}&indentId=${encodeURIComponent(indentId)}${rfqTypeQuery}`
        )
        .then((response) => {
          resolve(response?.data?.payload);
        })
        .catch((error) => {
          reject(error);
        });
    });

  fetchPendingPrMaterials = ({ entityId }) =>
    new Promise((resolve, reject) => {
      if (!entityId) {
        reject(new Error("entityId is required"));
        return;
      }

      axios
        .get(`${GET_PENDING_PR_MATERIALS}?entityId=${encodeURIComponent(entityId)}`)
        .then((response) => {
          resolve(response?.data?.payload);
        })
        .catch((error) => {
          reject(error);
        });
    });

  createNewProject = (values) => {
    return new Promise((resolve, reject) => {
      axios
        .post(CREATE_NEW_PROJECT, values)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  searchRfq = ({ entityId, searchParam, status, userIds }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(SEARCH_RFQ, { entityId, searchParam, status, userIds })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  searchRfqByDateFilter = ({
    projectId,
    entityId,
    searchParam,
    status,
    userIds,
    startDate,
    endDate,
    startDateOfClosing,
    endDateOfClosing,
    rfqTypes,
    categoryFilter,
    projectNames,
    businessDivision,
    workspaceType,
    approverId,
    teamUserIds,
    page
  }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(SEARCH_RFQ, {
          projectId,
          entityId,
          searchParam,
          status,
          userIds,
          startDate,
          endDate,
          startDateOfClosing,
          endDateOfClosing,
          rfqTypes,
          categoryFilter,
          projectNames,
          businessDivision,
          workspaceType,
          approverId,
          teamUserIds,
          page
        })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getApprovedRfqs = ({
    projectId,
    entityId,
    searchParam,
    status,
    userIds,
    startDate,
    endDate,
    startDateOfClosing,
    endDateOfClosing,
    rfqTypes,
    categoryFilter,
    projectNames,
    businessDivision,
    approvedByUserId
  }) => {
    return new Promise((resolve, reject) => {
      axios
        .post(GET_APPROVED_RFQ, {
          projectId,
          entityId,
          searchParam,
          status,
          userIds,
          startDate,
          endDate,
          startDateOfClosing,
          endDateOfClosing,
          rfqTypes,
          categoryFilter,
          projectNames,
          businessDivision,
          approvedByUserId
        })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  editRfqProject = (values, projectId) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`${EDIT_RFQ_PROJECT}?projectId=${projectId}`, values)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  editRfq = (newReqInfo) =>
    new Promise((resolve, reject) => {
      axios
        .patch(EDIT_RFQ, newReqInfo)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

    updateRFQDisplayRanks = ({ rfqId, displayRanks, rankVisibleSupplierIds, actionBy }) =>
      new Promise((resolve, reject) => {
        axios
          .patch(UPDATE_RFQ_DISPLAY_RANKS, { rfqId, displayRanks, rankVisibleSupplierIds, actionBy })
          .then((response) => resolve(response?.data))
          .catch((error) => reject(error));
      });
    

  updateRFQComparisonExclusion = ({ rfqId, supplierId, excluded, reason, actionBy }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(UPDATE_RFQ_COMPARISON_EXCLUSION, { rfqId, supplierId, excluded, reason, actionBy })
        .then((response) => resolve(response?.data))
        .catch((error) => reject(error));
    });
  requestRFQQuotationUpdate = ({ rfqId, supplierId, actionBy, managerMessage }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(REQUEST_RFQ_QUOTATION_UPDATE, { rfqId, supplierId, actionBy, managerMessage })
        .then((response) => resolve(response?.data))
        .catch((error) => reject(error));
    });

  trashedRfq = ({
    rfqId,
    entityId,
    userIds,
    currentStatus,
    actionBy,
    startDate,
    endDate,
  }) => {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${TRASH_RFQ}?rfqId=${rfqId}&entityId=${entityId}&currentStatus=${currentStatus}&page=1`,
          { actionBy, userIds, startDate, endDate }
        )
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  deleteRfq = ({
    rfqId,
    entityId,
    userIds,
    currentStatus,
    actionBy,
    startDate,
    endDate,
  }) => {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${DELETE_RFQ}?rfqId=${rfqId}&entityId=${entityId}&currentStatus=${currentStatus}&page=1`,
          { actionBy, userIds, startDate, endDate }
        )
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  restoreRfq = ({
    rfqId,
    entityId,
    userIds,
    currentStatus,
    actionBy,
    startDate,
    endDate,
  }) => {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${RESTORE_RFQ}?rfqId=${rfqId}&entityId=${entityId}&currentStatus=${currentStatus}&page=1`,
          { actionBy, userIds, startDate, endDate }
        )
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  inviteVendors = ({ rfqId, supplierIds }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(INVITE_VENDORS, { rfqId: rfqId, supplierIds: supplierIds })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  removeVendorsFromRfq = (rfqId, supplierId, deletedBy) =>
    new Promise((resolve, reject) => {
      axios
        .delete(`${REMOVE_VENDORS_RFQ}?rfqId=${rfqId}&supplierId=${supplierId}`, {
          data: { deletedBy },
        })

        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  restoreDeletedVendor = ({ rfqId, supplierId, additionalNote }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(REINVITE_RFQ, { rfqId, supplierId, additionalNote })
        .then((response) => {
          resolve(response?.data?.payload || response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  resendBounceEmail = (payload) =>
    new Promise((resolve, reject) => {
      axios
        .patch(`${UPDATE_EMAIL_VENDOR}`, payload)

        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  resendRfq = (payload) =>
    new Promise((resolve, reject) => {
      axios
        .patch(REINVITE_RFQ, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  mulResendRfq = (payload) =>
    new Promise((resolve, reject) => {
      axios
        .patch(MUL_REINVITE_RFQ, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  addVendorsToRfq = ({ rfqId, suppliers, requesterName, requestedBy, senderEmail }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(ADD_VENDORS_TO_RFQ, {
          rfqId,
          suppliers,
          requesterName,
          requestedBy,
          senderEmail
        })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  addEmailsToSupplier = ({ entityId, rfqId, supplierId, emails }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(ADD_EMAILS_TO_SUPPLIER, { entityId, rfqId, supplierId, emails })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  sendRfq = (userId, rfqId) =>
    new Promise((resolve, reject) => {
      axios
        .patch(SEND_RFQ, { userId, rfqId })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  getRfqs = ({ entityId, userIds, status, page }) =>
    new Promise((resolve, reject) => {
      axios
        .post(status === "" ? GET_RFQS : GET_RFQS_BY_STATUS, {
          entityId,
          userIds,
          status,
          page,
        })

        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  rfqFilterDate = ({ payload }) =>
    new Promise((resolve, reject) => {
      axios
        .post(RFQ_FILTER_DATE, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  getRfq = ({ entityId, rfqId }) =>
    new Promise((resolve, reject) => {
      axios
        .get(`${GET_RFQ}?entityId=${entityId}&rfqId=${rfqId}`)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  closeRfq = ({ payload }) =>
    new Promise((resolve, reject) => {

      const isApprovalDetailsEmpty =
      !payload.approvalDetails || payload.approvalDetails.length === 0;

      const url =
      (payload.rfqStatus === "REWORK" || payload?.isApprovalRequired) &&
      !isApprovalDetailsEmpty
        ? SEND_RFQ_FOR_APPROVAL_URL
        : APPROVE_RFQ_APPROVAL_URL;
      axios
      .patch(url, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  ApproveRfq = ({ payload }) =>
    new Promise((resolve, reject) => {

      const url = (payload.rfqStatus === "REWORK" ) ? SEND_RFQ_FOR_APPROVAL_URL : APPROVE_RFQ_APPROVAL_URL;  
      axios
      .patch(url, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  closeRfqWithoutVendor = ({ rfqId }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(CLOSE_RFQ_WITHOUT_VENDOR, { rfqId: rfqId })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  rejectRfqApproval = ({ payload }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(REJECT_RFQ_APPROVAL_URL,  payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteSingleRfq = ({ rfqId, userId, actionBy }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(`${DELETE_SINGLE_RFQ}?rfqId=${rfqId}&userId=${userId}`, {
          actionBy,
        })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  changeStatus = ({ payload }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(CHANGE_STATUS, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  getUserContacts = ({ userId }) =>
    new Promise((resolve, reject) => {
      axios
        .get(`${GET_USER_CONTACTS_BY_ID}?userId=${userId}`)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  quotationReceived = ({ payload }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(QUOTATION_RECEIVED, payload)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

  getRfqProjects = (entityId) =>
    new Promise((resolve, reject) => {
      axios
        .get(`${GET_RFQ_PROJECTS}?entityId=${entityId}`)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  getMemberList = (entityId) =>
    new Promise((resolve, reject) => {
      axios
        .get(`${GET_MEMBER_LIST}?entityId=${entityId}`)
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  getMaterialMaster = ({ entityId, search = "", page = 1, limit = 50, includeInactive = false }) =>
    new Promise((resolve, reject) => {
      if (!entityId) {
        reject(new Error("entityId is required"));
        return;
      }

      const params = new URLSearchParams({
        entityId,
        page: String(page),
        limit: String(limit),
      });
      if (search) params.append("search", search);
      if (includeInactive) params.append("includeInactive", "true");

      axios
        .get(`${GET_MATERIAL_MASTER}?${params.toString()}`)
        .then((response) => resolve(response?.data))
        .catch((error) => reject(error));
    });

  createMaterialMaster = (payload) =>
    new Promise((resolve, reject) => {
      axios
        .post(GET_MATERIAL_MASTER, payload)
        .then((response) => resolve(response?.data))
        .catch((error) => reject(error));
    });

  updateMaterialMaster = ({ id, ...payload }) =>
    new Promise((resolve, reject) => {
      axios
        .patch(`${GET_MATERIAL_MASTER}/${id}`, payload)
        .then((response) => resolve(response?.data))
        .catch((error) => reject(error));
    });

  deleteMaterialMaster = ({ id, ...payload }) =>
    new Promise((resolve, reject) => {
      axios
        .delete(`${GET_MATERIAL_MASTER}/${id}`, { data: payload })
        .then((response) => resolve(response?.data))
        .catch((error) => reject(error));
    });
}

const rfqService = new RfqService();

export default rfqService;
